export default __webpack_public_path__ + "static/media/trophy.47af5ba6.png";